// src/components/Progress/ProgressCard.tsx
import React from "react";
import ProgressBar from "./ProgressBar";

interface ProgressCardProps {
  title: string;
  code?: string;
  completedCount: number;
  requiredCount: number;
  completed: boolean;
}

const ProgressCard: React.FC<ProgressCardProps> = ({
  title,
  code,
  completedCount,
  requiredCount,
  completed,
}) => {
  const percentage =
    requiredCount > 0 ? Math.round((completedCount / requiredCount) * 100) : 0;

  return (
    <div className="relative rounded-sm border border-stroke bg-white p-5 shadow-default dark:border-strokedark dark:bg-boxdark">
      
      {/* ✅ Badge con colores reales */}
      <div
        className={`absolute right-3 top-3 px-2 py-1 rounded text-xs font-medium 
          ${
            completed
              ? "bg-[#3CA745] text-white" // SUCCESS REAL
              : "bg-[#EFEFEF] text-[#212B36] dark:bg-gray-700 dark:text-gray-100" // LIGHT NEUTRAL
          }
        `}
      >
        {completed ? "Completado" : "En progreso"}
      </div>

      <h4 className="font-medium text-black dark:text-white mb-2">
        {code && <span className="opacity-60 mr-1">({code})</span>}
        {title}
      </h4>

      <p className="text-xs text-gray-600 dark:text-gray-400 mb-3">
        Progreso:{" "}
        <span className="font-semibold text-black dark:text-white">
          {completedCount} / {requiredCount}
        </span>
      </p>

      <ProgressBar value={percentage} completed={completed} />
    </div>
  );
};

export default ProgressCard;
